import React, { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Toast from '../../Toast';
import workflowService from '../../../services/workflowService';
import { StyledDeleteWorkflowModal } from './DeleteWorkflowModal.style';
import Button from '../../Button';

const DeleteWorkflowModal = ({ onClose, isEdit }) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async e => {
      return await workflowService.deleteWorkflow(e);
    },
    onSuccess: response => {
      Toast({ type: 'success', message: response.detail });
      queryClient.invalidateQueries({ queryKey: ['get_all_workflows'] });
      onClose();
    },
    onError: err => {
      console.log(err);
      Toast({ type: 'error', message: err.detail });
    },
  });

  return (
    <StyledDeleteWorkflowModal>
      <h2 className="desc">Are you sure you want to delete</h2>
      <div className="btn-holder">
        <Button width="136px" variant="secondary-outline" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button width="150px" onClick={() => mutation.mutate(isEdit?.workflow_id)} loader={mutation.isPending}>
          Delete
        </Button>
      </div>
    </StyledDeleteWorkflowModal>
  );
};

export default DeleteWorkflowModal;
